import {
  Component,
  Inject,
  OnInit,
  Renderer2,
  ChangeDetectionStrategy
} from '@angular/core';
import { UtilsService } from '../../../shared/utils.service';
import { AppService } from '../../../app.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sites-task-analyses-revised-workflows-tabs',
  templateUrl: './sites-task-analyses-revised-workflows-tabs.component.html',
  styleUrls: ['./sites-task-analyses-revised-workflows-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesTaskAnalysesRevisedWorkflowsTabsComponent implements OnInit {
  path: string;
  site_id: number;
  ta_revised_id: number;
  ta_revised_workflow_id: number;

  constructor(
    public utils: UtilsService,
    public app: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public renderer: Renderer2
  ) {}

  ngOnInit() {
    this.ta_revised_workflow_id = this.dialogData.ta_revised_workflow.id;

    // get the task analysis id from the parent route params
    this.ta_revised_id = this.dialogData.ta_revised_id;

    // get the site id from the parent route params
    this.site_id = this.dialogData.site_id;

    // get sites path edit/view
    this.path = this.dialogData.path;
  }
}
